import React, { Component } from "react";

class IconBurguer extends Component {
    render() {
        const { opened, color, onClick } = this.props;

        let bar3ClassName =
            "w-20 h-2 rounded transition duration-300 ease-in-out transform " +
            color;
        let bar2ClassName = bar3ClassName + " mb-5";
        let bar1ClassName = bar2ClassName;

        if (opened) {
            bar1ClassName += " rotate-45 translate-y-7";
            bar2ClassName += " opacity-0 scale-50";
            bar3ClassName += " -rotate-45 -translate-y-7";
        }

        return (
            <button className="inline-block p-16" onClick={onClick}>
                <div className={bar1ClassName} />
                <div className={bar2ClassName} />
                <div className={bar3ClassName} />
            </button>
        );
    }
}

export default IconBurguer;
